import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import { pedidoMinimoService } from "src/services/apiPedidoMinimo";
import { modalCRUDService } from "src/services/modalCRUDService";

const FormCRUD = ({ properties }) => {
	const { tableRef, params, idRegistro, vlPedMinRuta, vlPedExtRuta } = properties;
	const [vlrPedMinimo, setVlrPedMinmo] = useState({ vlPedMinRuta, vlPedExtRuta });
	const dispatch = useDispatch();

	const handleSave = async () => {
		try {
			if (!vlrPedMinimo.vlPedMinRuta || !vlrPedMinimo.vlPedExtRuta) {
				dispatch({
					type: "setStateAlert",
					alert: {
						type: GlobalConstants.alertWarning,
						message: "Los campos no pueden estar vacíos.",
					},
				});
			}

			const responseSave = await pedidoMinimoService.actualizarById({
				id: idRegistro,
				vlPedMinRuta: vlrPedMinimo.vlPedMinRuta,
				vlPedExtRuta: vlrPedMinimo.vlPedExtRuta,
			});

			if (responseSave.status) {
				const responseActualizar = await pedidoMinimoService.ejecutarPedidoCandado();
				if (responseActualizar.status) {
					const rowIndex = params.rowIndex;
					const rowNode = tableRef.current.api.getRowNode(rowIndex);
					rowNode.updateData({
						...rowNode.data,
						vlPedMinRuta: vlrPedMinimo.vlPedMinRuta,
						vlPedExtRuta: vlrPedMinimo.vlPedExtRuta,
					});

					modalCRUDService.clear();

					dispatch({
						type: "setStateAlert",
						alert: {
							type: GlobalConstants.alertSuccess,
							message: "Los cambios se han guardado correctamente.",
						},
					});
				}
			}
		} catch (error) {
			console.log(error.message);
			dispatch({
				type: "setStateAlert",
				alert: {
					type: GlobalConstants.alertError,
					message: "Error al guardar los cambios.",
				},
			});
		}
	};

	const handleChange = (event) => {
		const { name, value } = event;
		setVlrPedMinmo((prev) => ({ ...prev, [name]: value }));
	};

	return (
		<div className='container'>
			<div className='row align-items-center'>
				<div className='col-8 col-md-8 col-lg-8 '>
					<h5 className='m-0'>Actualiza los valores de pedido.</h5>
				</div>
				<div className='col-4 col-md-4 col-lg-4 d-flex justify-content-end align-items-center'>
					<Tooltip title='Guardar Cambios'>
						<a onClick={handleSave} className='icon-container-actions d-flex'>
							<div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
							<i style={{ color: Colors.COLOR_GREEN_DARK }} className='fas fa-check fa-2x' />
						</a>
					</Tooltip>
				</div>
			</div>
			<div className='row mt-4'>
				<div className='col-12 col-md-6 col-lg-6'>
					<InputForm
						label={"Valor Pedido Mínimo Ruta"}
						identificador={"vlPedMinRuta"}
						type='number'
						inputProps={{}}
						value={vlrPedMinimo.vlPedMinRuta}
						handleChange={handleChange}
					/>
				</div>
				<div className='col-12 col-md-6 col-lg-6'>
					<InputForm
						label={"Valor Pedido Extra Ruta"}
						identificador={"vlPedExtRuta"}
						type='number'
						inputProps={{}}
						value={vlrPedMinimo.vlPedExtRuta}
						handleChange={handleChange}
					/>
				</div>
			</div>
		</div>
	);
};

export default FormCRUD;
